<template>
    <v-card class="mx-auto" :color="color" theme="dark" max-width="600" height="100%">
        <v-card-title class="pb-1">
            <v-icon start>$apps-box</v-icon>
            <span class="text-h6 font-weight"
                >Request Submission
                <v-chip
                    v-if="isMultiAssign"
                    class="ml-2 font-weight-bold text-caption"
                    color="orange"
                >
                    Multi Assign Enabled
                </v-chip>
            </span>
        </v-card-title>

        <v-card-text class="font-weight-bold">
            <div class="h1">Functional Protocol:</div>
            <div class="d-flex ml-md-8 justify-start">{{ protocols[0].name }}</div>
            <span class="h1 font-weight-bold">{{
                `Container: ${container.name} - ${container.columns} x ${container.rows}`
            }}</span>
        </v-card-text>
    </v-card>
</template>

<script>
import { defineComponent } from "vue";

import { mapGetters } from "vuex";

export default defineComponent({
    name: "ContainerCard",

    computed: {
        ...mapGetters("plateCreate", ["container", "protocols", "isMultiAssign"]),
        color() {
            return this.isMultiAssign ? "blue darken-4" : "blue";
        },
    },
});
</script>

<style scoped></style>
